import { eventsData } from "../eventsData";

const isEventPast = (tillDate) => {
    const today = new Date();
    const endDate = new Date(tillDate);
    return endDate < today;
};


const Events = () => {
    return (
        <section
            className="px-4 sm:px-8 md:px-14 lg:px-24 sm:pt-1 md:pt-4 lg:pt-12"
            id="eventsNav"
        >
            <h1 className="text-xl md:text-3xl lg:text-4xl text-center text-brown-700 font-bold font-heading">
                Events
            </h1>

            {eventsData.sort((a, b) => {
                const aHasSort = a.sortId != undefined;
                const bHasSort = b.sortId != undefined;

                if(aHasSort && bHasSort) return a.sortId - b.sortId;

                if(aHasSort) return -1;

                if(bHasSort) return 1;

                return new Date(b.tillDate) - new Date(a.tillDate)
            }).map((event) => {
                const isPast = isEventPast(event.tillDate);
                return (
                    <div
                        key={event.id}
                        className="w-full lg:w-[90%] mx-auto my-6 bg-beige/60 rounded-lg shadow-lg"
                    >
                        <div className="event-top flex items-center gap-4 p-4 sm:p-6 lg:px-10 font-heading text-brown-700 font-semibold">
                            <div
                                className={`w-[65px] md:w-[80px] shrink-0 shadow-inset rounded-lg py-1 bg-beige/70 font-para
                                ${isPast ? "opacity-60 line-through" : "text-brown-600"}`}
                            >
                                <p className="text-center text-base text-sm md:text-md lg:text-lg">
                                    {event.fromDay}
                                </p>
                                <p className="text-center text-base text-sm md:text-md lg:text-lg">
                                    {event.fromMonth}
                                </p>
                                {event.tillText && <div className="border-t-2 border-dashed border-brown-600 pt-1">
                                    <p className="text-center text-xs">
                                        {event.tillText}
                                    </p>
                                </div>}
                            </div>
                            <h1 className="text-base text-md md:text-lg lg:text-xl leading-tight">
                                {event.title}
                            </h1>
                        </div>
                        <div className="event-body px-4 sm:px-6 lg:px-10 pb-6 font-para text-brown-700 text-base sm:text-lg">
                            <div className="flex flex-col gap-3 mb-4 md:mb-6 justify-center items-center">
                                {event.images.map((img, index) => (
                                    <div className="max-w-[900px]">
                                        <img
                                            key={index}
                                            className="rounded-lg"
                                            src={`/images/events/${img}`}
                                            alt={event.title}
                                        />
                                    </div>

                                ))}
                            </div>
                            <div className="event-details text-sm md:text-lg">
                                {event.Detail1 && <p>{event.Detail1}</p>}
                                {event.Detail2 && <p>{event.Detail2}</p>}
                                {event.description && <p>{event.description}</p>}
                                {event.link && <p>click <a href={event.link} className="text-blue-600 underline" target="_blank">here</a> to know more</p>}
                                {event.location && <a href={event.locationLink} className="text-blue-600 underline" target="_blank">{event.location}</a>}
                            </div>
                        </div>
                    </div>
                );
            })}
        </section>
    );
};

export default Events;